<template>
  <div
    class="product-image"
    :style="`background-image: url(https://storage.googleapis.com/emma-static/products/${path}_1200.jpg)`"
  />
</template>

<script>
export default {
  props: ['path']
}
</script>

<style lang="scss" scoped>
.product-image {
  flex-shrink: 0;
  display: inline-block;

  width: 8rem;
  height: 8rem;
  margin: 0 1rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>
